export default __webpack_public_path__ + "static/static-page-banner-m-dc88499ad4d052b4d11d313161597962.jpg";